import axiosTemplate from '../../utils/axiosTemplate';

export default (query) => {
  const promise = new Promise((resolve, reject) => {
    let params = query || {};
    axiosTemplate(process.env.VUE_APP_GATEWAY_ENDPOINT)
      .get(`/v3/providers/${params.id}/daily?locationId=0`, { params })
      .then(
        ({ data }) => {
          let profiles = [];
          if (data.data) {
            profiles.data = data.data;
          }
          resolve(profiles);
        },
        (error) => {
          reject(error);
        }
      );
  });

  return promise;
};
